import styled from '@emotion/styled'
import { Input, InputProps } from '@mui/material'
import { MainFrameBG } from '../../../pure-js/libs/Colors'
import { BorderRadixes } from '../enums/BorderRadixes'
import { tinySpacing } from '../enums/Spacings'
import Box from './Box'

export function TextFieldFormExperimental({
  field,
  fieldState,
  headerText,
  inputProps,
  hasError
}: {
  field
  fieldState
  headerText?: string
  inputProps?: InputProps
  hasError?: boolean
}) {
  const hasValidationError = fieldState.error
  return (
    <Box fullWidth>
      <Container fullWidth hasValidationError={hasError || hasValidationError}>
        {headerText && (
          <Box top left spacing={tinySpacing}>
            {headerText}
          </Box>
        )}
        <Input
          {...field}
          fullWidth
          disableUnderline
          size="small"
          sx={{
            borderRadius: BorderRadixes.regular,
            paddingLeft: tinySpacing,
            ...field.sx
          }}
          {...inputProps}
        />
      </Container>

      {hasValidationError && <GenericErrorComponent fieldState={fieldState} />}
    </Box>
  )
}

const Container = styled(Box)<{ hasValidationError?: boolean }>`
  background-color: ${MainFrameBG};
  border-radius: ${BorderRadixes.small};
`

const ErrorText = styled(Box)`
  color: #ef4444;
  font-size: 14px;
  margin-top: 4px;
`

export function GenericErrorComponent({ fieldState }) {
  return <ErrorText>{fieldState?.error?.message}</ErrorText>
}
